<template>
  <div>
    
        <a-menu
          mode="inline"
          :default-selected-keys="['1']"
          :default-open-keys="['sub1']"
          :style="{ height: '100%', borderRight: 0 }"
          @click="handleClick"
        >
          <a-sub-menu key="sub1" @titleClick="titleClick" v-if="manager">
            <span slot="title"><a-icon type="user" />人员管理</span>
            <a-menu-item key="1">
              用户
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub2" @titleClick="titleClick">
            <span slot="title"><a-icon type="laptop" />终端管理</span>
            <a-menu-item key="5">
              终端
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub3" @titleClick="titleClick">
            <span slot="title"><a-icon type="laptop" />LDH12</span>
            <a-menu-item key="7">
              激活码
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub4" @titleClick="titleClick">
            <span slot="title"><a-icon type="laptop" />网络基站</span>
            <a-menu-item key="8">
              网络基站
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub5" @titleClick="titleClick">
            <span slot="title"><a-icon type="laptop" />千寻账号</span>
            <a-menu-item key="9">
              千寻账号
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub6" @titleClick="titleClick">
            <span slot="title"><a-icon type="laptop" />版本控制</span>
            <a-menu-item key="2">
              产品型号
            </a-menu-item>
          </a-sub-menu>
        </a-menu>
  </div>
</template>
<script>
export default {
  data() {
    var show = false;
    if(this.$store.state.user=="15")
      show = true;
    return {
      manager:show
    }
  },
  methods: {
    handleClick(e) {
      console.log('click', e);
      switch(e.key)
      {
        case '1':
          this.$router.push('/home')
          break;
        case '5':
          this.$router.push('/home/terminallist')
          break;
        case '7':
          this.$router.push('/home/ldh12active')
          break;
        case '8':
          this.$router.push('/home/basestationlist')
          break;
        case '9':
          this.$router.push('/home/qxaccountlist')
          break;
        case '2':
          this.$router.push('/home/versionlist')
          break;

      }
    },
    titleClick(e) {
      console.log('titleClick', e);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Sidebar.vue